import { render, staticRenderFns } from "./CheckinTransitiveInferenceHelp.vue?vue&type=template&id=98a36a10&"
import script from "./CheckinTransitiveInferenceHelp.vue?vue&type=script&lang=js&"
export * from "./CheckinTransitiveInferenceHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports